module.exports = __webpack_public_path__ + "static/media/angry.aea763a9.png";